import { useState, useEffect } from "react";
import API_CIFRA from "../config/Variables_apis";

export const useMarkers = (documento) => {
  const [markers, setMarkers] = useState([]);

  const fetchMarkersFromAPI = async (documento) => {
    try {
      const response = await fetch(API_CIFRA.alertasSearch(documento));
      const data = await response.json();
      const apiMarkers = data.map((marker) => ({
        id: marker.id,
        position: {
          lat: parseFloat(marker.latitud),
          lng: parseFloat(marker.longitud),
        },
        tipoincidencia: marker.tipoincidencia,
        estado: marker.estado,
      }));
      setMarkers(apiMarkers);
    } catch (error) {
      console.error("Error fetching markers from API:", error);
    }
  };

  useEffect(() => {
    if (documento) fetchMarkersFromAPI(documento);
  }, [documento]);

  return { markers, setMarkers };
};